export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthArea_03.1b2990fc.jpg";